import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder,FormGroup, Validators } from '@angular/forms'
import { FormItem } from 'src/app/pages/main/module/base-data/area-building/model/form-item-interface';
import { ListOfOption } from 'src/app/pages/main/module/base-data/area-building/model/list-of-option.interface';
@Component({
  selector: 'app-edit-form-inline',
  templateUrl: './edit-form-inline.component.html',
  styleUrls: ['./edit-form-inline.component.scss'],
})
export class EditFormInlineComponent implements OnInit {
  @Input() dbName = "";
  @Input() formItems: FormItem[] = [];
  @Input() listOfOption: ListOfOption | undefined;
  @Output() formValue = new EventEmitter<any>();
  @Output() selectValue = new EventEmitter<any>();

  formGroup: FormGroup | undefined;

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    switch (this.dbName) {
      case 'area_building':
        this.formGroup = this.fb.group({
          garden: ["", [Validators.required]],
          area: ["", [Validators.required]],
          building: ["", [Validators.required]],
          floor: ["", [Validators.required]],
          functionRoom: ["", [Validators.required]],
          roomNumber: ["", [Validators.required]],
          isvalid: ["", [Validators.required]]
        });
        break;
      case 'base_material_list':
        this.formGroup = this.fb.group({
          bigType: ["", [Validators.required]],
          middleType: ["", [Validators.required]],
          building: ["", [Validators.required]],
          smallType: ["", [Validators.required]],
          projectName: ["", [Validators.required]],
          brandNative: ["", [Validators.required]],
          specType: ["", [Validators.required]],
          pn: ["", [Validators.required]],
          isvalid: ["", [Validators.required]]
        });
        break;
      case 'vendor_info':
        this.formGroup = this.fb.group({
          type: ["", [Validators.required]],
          outsource: ["", [Validators.required]],
          vendorCode: ["", [Validators.required]],
          technical: ["", [Validators.required]],
          profit: ["", [Validators.required]],
          taxRate: ["", [Validators.required]],
          contact: ["", [Validators.required]],
          tel: ["", [Validators.required]],
          email: ["", [Validators.required]],
          isvalid: ["", [Validators.required]]
        });
        break;
      default:
        break;
    }


    // 监听表单中每个字段值的变化
    this.formGroup?.valueChanges.subscribe((change: string) => {
      // 参数 change 指向最新值
      this.selectChanged(change);
    });
  }

  submitForm() {
    if (this.formGroup) {
      this.formValue.emit(this.formGroup.value);
    }
  }


  /**
   * @function selectChanged:selector中选择的值
   * @param changevalue  当前表单中的值
   */
  selectChanged(changevalue) {
    /* 
    changevalue[key] = null: 取消选择的column
    changevalue[key] = "": 未选择的column
    changevalue[key]中有 === null的 */
    if (Object.values(changevalue).some(value => value === null)) {
      let keysArr = Object.keys(changevalue);
      let valuesArr = Object.values(changevalue);
      // 获取changevalue=null的下标
      const cancelIndex = valuesArr.findIndex((e: string) => e === null);
      // cancelIndex后的选择都清空,cancelIndex前有选择的不变
      for (let i = 0; i < valuesArr.length; i++) {
        if (i >= cancelIndex) {
          // 清空select的内容,即value=""
          changevalue[keysArr[i]] = "";
        }
      }
      this.formGroup.patchValue(changevalue);//放此处执行selectChanged()次数较少,只有value有变更才执行
    }
    this.selectValue.emit(changevalue);
  }
}
